import React, { useMemo } from "react";
import style from "css/admin/component.module.css";
import { Modal, Button, ConfigProvider } from "antd";

function PeriodDeleteConfirmModal({ open, onCancel, onConfirm, loading = false, record = null }) {
  const periodName = useMemo(() => {
    const v = record?.PERIOD_NM == null ? "" : String(record.PERIOD_NM).trim();
    return v;
  }, [record]);

  return (
    <Modal
      // title={
      //   <span className={style.searchItem_label} style={{ fontSize: 18 }}>
      //     삭제 확인
      //   </span>
      // }
      open={open}
      onCancel={onCancel}
      closable={false}
      maskClosable={!loading}
      styles={{ content: { borderRadius: 12 }, mask: { backdropFilter: "none" } }}
      footer={
        <ConfigProvider
          theme={{
            token: { colorPrimary: "#f65c22" },
            components: {
              Button: {
                colorPrimaryHover: "#e4561f",
                colorPrimaryActive: "#cc4b1b",
              },
            },
          }}
        >
          <div style={{ display: "flex", gap: 8, width: "100%" }}>
            <Button
              key="cancel"
              onClick={onCancel}
              disabled={loading}
              style={{ flex: 1, height: 40, borderRadius: 5, fontSize: 18 }}
            >
              취소
            </Button>
            <Button
              key="submit"
              type="primary"
              onClick={onConfirm}
              loading={loading}
              style={{ flex: 1, height: 40, borderRadius: 5, fontSize: 18 }}
            >
              삭제
            </Button>
          </div>
        </ConfigProvider>
      }
      centered
    >
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, paddingTop: 6 }}>
        <div className={style.searchItem_label} style={{ fontSize: 16, textAlign: "center" }}>
          {periodName || "-"}
        </div>
        <div className={style.searchItem_label} style={{ fontSize: 15, fontWeight: 500, textAlign: "center" }}>
          신청 기간을 삭제하시겠습니까?
        </div>
      </div>
    </Modal>
  );
}

export default PeriodDeleteConfirmModal;


